import React from 'react';
import listIcon3 from 'assets/images/list-icon3.svg';
import listIcon4 from 'assets/images/list-icon4.svg';
import listIcon5 from 'assets/images/list-icon5.svg';
import listIcon6 from 'assets/images/list-icon6.svg';
import listIcon2 from 'assets/images/list-icon2.svg';
import listIcon1 from 'assets/images/list-icon1.svg';
import loadable from '@loadable/component';

const LazyImg = loadable(() => import('../common/LazyImg'));

const GridCard = () => (
  <section className='grid-card'>
    <div className='container'>
      <div className='grid-card__intro'>
        <h2 className='grid-card__intro-title'>
          By a refreshingly thoughtful company.
          <br />
          🤗
        </h2>
        <div className='grid-card__intro-description'>
          <p>
            Air purifier manufacturers have built their businesses on features and benefits that can’t be seen or
            touched, making it easy for them to mislead consumers.
          </p>
          <p>We made it our mission to do things differently:</p>
        </div>
      </div>
      <ul className='grid-card__list'>
        <li className='grid-card__list-item grid-card__list-item--fullwidth'>
          <LazyImg src={listIcon1} alt='list-icon1' />
          <p>Speaking honestly to customers and treating them like family</p>
        </li>
        <li className='grid-card__list-item'>
          <LazyImg src={listIcon2} alt='list-icon2' />
          <p>Launching Mila at an affordable price</p>
        </li>
        <li className='grid-card__list-item'>
          <LazyImg src={listIcon3} alt='list-icon3' />
          <p>Eliminating the hassle of filter replacement</p>
        </li>
        <li className='grid-card__list-item'>
          <LazyImg src={listIcon4} alt='list-icon4' />
          <p>Customizing each unit to people’s unique needs</p>
        </li>
        <li className='grid-card__list-item grid-card__list-item--fullwidth'>
          <LazyImg src={listIcon5} alt='list-icon5' />
          <p>Standing behind our product with a money back guarantee</p>
        </li>
        <li className='grid-card__list-item grid-card__list-item--fullwidth'>
          <LazyImg src={listIcon6} alt='list-icon6' />
          <p>Manufacturing with the environment in mind</p>
        </li>
      </ul>
      <h3 className='grid-card__bottom-title'>
        Everyone has the right to clean air. And now with Mila, everyone has the
        opportunity to breathe it.
        {' '}
      </h3>
    </div>
  </section>
);

export default GridCard;
